import { PUBLIC_SENTRY_ENVIRONMENT } from '$env/static/public';

export const sharedConfig = {
	enabled: PUBLIC_SENTRY_ENVIRONMENT !== 'DISABLED',
	dsn: 'https://240602ccc37e4e1f91d8b917af15b820@o1154464.ingest.sentry.io/6470131',
	environment: PUBLIC_SENTRY_ENVIRONMENT
} as const;
